import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Settings() {
    const { user, setUser } = useAuth();
    const [form, setForm] = useState({ name: user?.name || "", firm_name: user?.firm_name || "", hourly_rate: user?.hourly_rate || 300 });
    const [busy, setBusy] = useState(false);

    const save = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const { data } = await api.patch("/auth/profile", { ...form, hourly_rate: parseFloat(form.hourly_rate) });
            setUser(data);
            toast.success("Saved");
        } catch { toast.error("Failed"); }
        finally { setBusy(false); }
    };

    return (
        <div className="max-w-2xl mx-auto animate-fade-up">
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500">Settings</div>
            <h1 className="font-display text-4xl font-extrabold tracking-tight mb-8">Workspace.</h1>

            <form onSubmit={save} className="card-sharp p-7 space-y-5">
                <div>
                    <label className="label-sharp">Full name</label>
                    <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input-sharp" data-testid="settings-name-input" />
                </div>
                <div>
                    <label className="label-sharp">Firm name</label>
                    <input value={form.firm_name} onChange={(e) => setForm({ ...form, firm_name: e.target.value })} className="input-sharp" data-testid="settings-firm-input" />
                </div>
                <div>
                    <label className="label-sharp">Default hourly rate (USD)</label>
                    <input type="number" min={0} value={form.hourly_rate} onChange={(e) => setForm({ ...form, hourly_rate: e.target.value })} className="input-sharp w-40" data-testid="settings-rate-input" />
                </div>
                <div>
                    <label className="label-sharp">Email</label>
                    <input value={user?.email} disabled className="input-sharp bg-slate-100 text-slate-500" />
                </div>
                <div>
                    <label className="label-sharp">Auth provider</label>
                    <div className="font-mono text-xs uppercase tracking-wider text-slate-600">{user?.auth_provider || "password"}</div>
                </div>
                <div className="flex justify-end pt-4">
                    <button disabled={busy} type="submit" className="btn-primary disabled:opacity-60" data-testid="settings-save-button">
                        {busy ? "Saving…" : "Save changes"}
                    </button>
                </div>
            </form>
        </div>
    );
}
